export enum IPayerTabs {
  addNewPayer = "1",
  payerTable = "2",
}
